import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import type { GetCaseTypeAssignmentOptionsQuery } from './get-case-type-assignment-options.query';
import type { GetCaseTypeAssignmentOptionsResult } from './get-case-type-assignment-options.result';

@Injectable({ providedIn: 'root' })
export class GetCaseTypeAssignmentOptionsUseCase {
  private readonly _repository = inject(CasesRepository);

  public execute(query: GetCaseTypeAssignmentOptionsQuery): Observable<GetCaseTypeAssignmentOptionsResult> {
    return this._repository
      .getCaseTypeAssignmentOptions(query.caseTypeId, query.search)
      .pipe(map((options) => ({ options })));
  }
}
